import { ConvexMessage, ClientMessage } from "../../types/message";

/**
 * Converts an array of ConvexMessage objects to an array of ClientMessage objects.
 * @param convexMessages Array of ConvexMessage
 * @returns Array of ClientMessage
 */
export function convexMessagesToClientMessages(convexMessages: ConvexMessage[]): ClientMessage[] {
  return convexMessages.map((msg) => ({
    id: msg._id,
    content: msg.content,
    isAi: msg.isAi,
    timestamp: msg.timestamp,
    images: msg.images,
    textAttachments: msg.textAttachments && msg.textAttachments.length > 0
      ? msg.textAttachments
      : [],
    branchId: msg.branchId,
    tool_calls: msg.tool_calls ?? null,
    tool_results: msg.tool_results ?? null
  }));
}

/**
 * Drops turns whose reply never arrived (an empty AI message with no tool
 * activity) along with the user message that asked them. A failed guest or
 * incognito reply leaves its placeholder in local state; sending it back as
 * context makes every later request fail too.
 */
export function withoutUnansweredTurns(context: ClientMessage[]): ClientMessage[] {
  const result: ClientMessage[] = [];
  for (const message of context) {
    const unanswered = message.isAi && !message.content.trim() && !message.tool_calls && !message.tool_results;
    if (!unanswered) {
      result.push(message);
    } else if (result.length > 0 && !result[result.length - 1].isAi) {
      result.pop();
    }
  }
  return result;
}
